export enum UserRoles {
  ProvinceGuildRoomAdmin = "ProvinceGuildRoomAdmin",
  CountyGuildRoomAdmin = "CountyGuildRoomAdmin",
  UserReal = "UserReal",
  UserLegal = "UserLegal",
  UnionSecretariat = "UnionSecretariat"
}

